const NAME = "CONTRACTOR_SETTINGS";

export default NAME;
